import React, { useCallback, useEffect, useState } from "react";
import styled from "styled-components";
import Steps from "../../components/common/Steps";
import Information from "../../components/checkout/tabs/Information";
import Payment from "../../components/checkout/tabs/Payment";
import { useAppContext } from "../../context/useAppContext";
import { useNavigate } from "react-router-dom";
import { useRequest } from "../../hooks/useRequest";
import IconWithTextList from "../../components/common/IconWithTextList";
import { toast } from "react-toastify";

const CheckoutStyle = styled.div`
  padding: 70px 0;
  .page__title {
    color: #303030;
    text-align: center;
    font-size: 42px;
    font-weight: 700;
    line-height: 51px;
    margin-bottom: 27px;
  }
  .icon_with_text {
    margin-top: 140px;
    padding: 60px 0 0;
    border-top: 1px solid rgba(48, 48, 48, 0.25);
    width: 100vw;
  }
  @media (max-width: 768px) {
    padding: 40px 0;
    .page__title {
      font-size: 20px;
      line-height: 28px;
      margin-bottom: 15px;
    }
  }
`;

const tabsList = [
  {
    id: 1,
    title: "Specification",
    component: ({
      handleChangeBilling,
      handleOrderNow,
      orderSummaryData,
      getShippingRateCaPost,
      caRateService,
      setCaRateService,
      checkoutAddress,
      setBillingType,
      billingType,
    }) => (
      <Information
        handleChangeBilling={handleChangeBilling}
        handleOrderNow={handleOrderNow}
        orderSummaryData={orderSummaryData}
        checkoutAddress={checkoutAddress}
        setBillingType={setBillingType}
        billingType={billingType}
        getShippingRateCaPost={getShippingRateCaPost}
        caRateService={caRateService}
        setCaRateService={setCaRateService}
      />
    ),
  },
  {
    id: 2,
    title: "Description",
    component: ({ createOrderData, orderSummaryData, billingType, checkoutCartData }) => (
      <Payment
        createOrderData={createOrderData}
        orderSummaryData={orderSummaryData}
        billingType={billingType}
        checkoutCartData={checkoutCartData}
      />
    ),
  },
];

const Checkout = () => {
  const [activeStep, setActiveStep] = useState(1);
  const { checkoutCartData, appliedCoupon, appliedReward } = useAppContext();
  const navigate = useNavigate();
  const [orderSummaryData, setOrderSummaryData] = useState([]);
  const [fetchOrderSummary] = useRequest("/order/checkout/summary");
  const checkoutCartId = checkoutCartData?._id;
  const [checkoutAddress, setCheckoutAddress] = useState({
    billing: "",
    shipping: "",
    billingPhone: "",
    shippingPhone: "",
  });
  const [createOrderData, setCreateOrderData] = useState();
  const [caRateService, setCaRateService] = useState(0);

  const [billingType, setBillingType] = useState("deliver");

  useEffect(() => {
    if (!checkoutCartId) return navigate("/cart");
    async function getOrderSummary(cartId, coupon) {
      const path = `/order/checkout/summary`;
      const response = await fetchOrderSummary({
        path: path,
        method: "POST",
        body: JSON.stringify({
          cartId,
          coupon,
          shippingCharges : caRateService || 0,
          usedReward: appliedReward || 0,
        }),
      });
      if (response.success) {
        setOrderSummaryData(response?.data);
      }
    }
    getOrderSummary(checkoutCartId, appliedCoupon);
  }, [checkoutCartId, appliedCoupon, caRateService]);

  const handleChangeBilling = useCallback((e, address, addressType, method, phone) => {
    setCheckoutAddress((prev) => ({ ...prev, [method]: address, [method + 'Phone']: phone }));
  }, []);

  const handleOrderNow = () => {
    setActiveStep(activeStep + 1);
  };

  async function getShippingRateCaPost(alt = 1) {
    const path = `/order/checkout/shipping/canada-post/rates?alt=${alt}`;
    const response = await fetchOrderSummary({
      path: path,
      method: "POST",
      body: JSON.stringify({
        cart_id: checkoutCartId,
      }),
    });

    if (response.success) {
      setCaRateService(response?.data);
      return response?.data || 1;
    }

    toast.success(response.message);
    return 0
  }


  const handleStepClick = (step) => {
    if (step?.id > activeStep) {
      return;
    }
    setActiveStep(step?.id);
  };

  useEffect(() => {
    if (!checkoutCartId) return;
    const products = checkoutCartData.items.map((item) => ({
      productId: item.product._id,
      variation: "",
      qty: item.quantity,
      price: item.product.price,
    }));

    // New object in desired format
    const newObject = {
      products,
      subtotal: orderSummaryData?.totalAmount,
      shippingCharge: orderSummaryData?.shippingCharges,
      coupon: appliedCoupon,
      deliveryType: billingType,
      paymentRefNumber: "",
      billingAddress: checkoutAddress?.billing,
      shippingAddress: checkoutAddress?.shipping,
      billingPhone: checkoutAddress?.billingPhone,
      shippingPhone: checkoutAddress?.shippingPhone,
    };

    setCreateOrderData(newObject);
  }, [checkoutAddress, orderSummaryData, checkoutCartData]);

  return (
    <>
      <CheckoutStyle>
        <div className="container">
          <div className="page__title">Checkout</div>
          <div className="checkout__steps">
            <Steps activeIndex={activeStep} handleStepClick={handleStepClick} />
          </div>
          {tabsList
            ?.find((item) => item?.id === activeStep)
            ?.component({
              handleChangeBilling,
              handleOrderNow,
              orderSummaryData,
              getShippingRateCaPost,
              caRateService,
              setCaRateService,
              checkoutAddress,
              createOrderData,
              billingType,
              setBillingType,
              checkoutCartData,
            })}
        </div>
      </CheckoutStyle>
      {activeStep === 2 && <IconWithTextList />}
    </>
  );
};

export default Checkout;
